export const MINIMUM_ACCOUNT_AGE = 18;

// Birth dates use UTC calendar days on every client and in Firebase eligibility.
export function parseBirthDateInput(value: string): Date | null {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
  const date = new Date(`${value}T00:00:00.000Z`);
  return Number.isNaN(date.getTime()) || formatBirthDateInput(date) !== value ? null : date;
}

export function formatBirthDateInput(value: Date): string {
  return Number.isNaN(value.getTime()) ? "" : value.toISOString().slice(0, 10);
}

export function isAdultBirthDate(birthDate: Date | null | undefined, now = new Date()): boolean {
  if (!birthDate || Number.isNaN(birthDate.getTime()) || birthDate > now) return false;
  const birthdayPending = now.getUTCMonth() < birthDate.getUTCMonth() ||
    (now.getUTCMonth() === birthDate.getUTCMonth() && now.getUTCDate() < birthDate.getUTCDate());
  return now.getUTCFullYear() - birthDate.getUTCFullYear() - Number(birthdayPending) >= MINIMUM_ACCOUNT_AGE;
}

export function assertAdultBirthDate(birthDate: Date | null | undefined): asserts birthDate is Date {
  if (!isAdultBirthDate(birthDate)) {
    throw Object.assign(new Error("You must be at least 18 years old."), { code: "auth/minimum-age-required" });
  }
}
